// 封装一个公共的 HTTP 请求类
import BaseService from "@/api/base";

class CategoryService extends BaseService {
    // 基础的 API 地址
    private login_path = "/login"
    private search_at_tree_path = "/1password/api/v1/category/search_at_tree"
    private create_path = "/1password/api/v1/category/create"
    private update_path = "/1password/api/v1/category/update"
    private remove_path = "/1password/api/v1/category/remove"

    // 封装 GET 请求方法
    public async searchAtTree(query: any = {}): Promise<any> {
        return await this.getFetchData(this.search_at_tree_path, query);
    }

    public async save(form: any = {}): Promise<any> {
        if(!form.id){
            return await this.postFetchData(this.create_path, form);
        }

        return await this.postFetchData(this.update_path, form);
    }
    public async remove(form: any = {}): Promise<any> {
        return await this.postFetchData(this.remove_path, form);

    }
}

export default CategoryService;
